(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const deliveryDateInput = document.getElementById('delivery-date');
    const deliveryTimeslotSelect = document.getElementById('delivery-timeslot');
    const checkoutButton = document.getElementById('checkout-button');
    const dateError = document.getElementById('date-error');
    const timeslotError = document.getElementById('timeslot-error');
    const istTimeDisplay = document.getElementById('ist-current-time');

    // Time slots configuration
    const timeSlots = [{ value: '12pm-6pm', label: '12:00 PM - 6:00 PM' }];

    // Authoritative server time — corrects wrong device clocks
    let serverOffsetMs = 0; // serverNow - localNow

    async function syncServerTime() {
      try {
        const res = await fetch('/cart.js', { cache: 'no-store' });
        const dateHeader = res.headers.get('date'); // Shopify server UTC time
        if (dateHeader) {
          const serverNow = new Date(dateHeader).getTime();
          if (!Number.isNaN(serverNow)) {
            serverOffsetMs = serverNow - Date.now();
          }
        }
      } catch (e) {
        serverOffsetMs = 0; // fall back to device clock if fetch fails
      }
    }

    function getISTDate() {
      const now = new Date(Date.now() + serverOffsetMs); // server-corrected, not raw device time
      try {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Asia/Kolkata',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        }).formatToParts(now);

        const get = (type) => parts.find((p) => p.type === type).value;
        const year = parseInt(get('year'));
        const month = parseInt(get('month')) - 1;
        const day = parseInt(get('day'));
        let hour = parseInt(get('hour'));
        const minute = parseInt(get('minute'));
        const second = parseInt(get('second'));
        if (hour === 24) hour = 0;

        return new Date(Date.UTC(year, month, day, hour, minute, second));
      } catch (e) {
        // Browser lacks timezone data: IST = UTC + 5:30 (no DST), safe because base is server time
        return new Date(now.getTime() + 5.5 * 60 * 60 * 1000);
      }
    }

    // Format IST time for display
    function formatISTTimeDisplay() {
      const istDate = getISTDate();
      const options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      };

      // Format in IST manually since we've already converted
      const dateStr = istDate.toISOString();
      const year = istDate.getUTCFullYear();
      const month = istDate.getUTCMonth();
      const day = istDate.getUTCDate();
      const hours = istDate.getUTCHours();
      const minutes = istDate.getUTCMinutes();
      const seconds = istDate.getUTCSeconds();

      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const weekday = dayNames[new Date(Date.UTC(year, month, day)).getUTCDay()];

      const hour12 = hours % 12 || 12;
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const minuteStr = String(minutes).padStart(2, '0');
      const secondStr = String(seconds).padStart(2, '0');

      return `${weekday}, ${monthNames[month]} ${day}, ${year} - ${hour12}:${minuteStr}:${secondStr} ${ampm}`;
    }

    // Update IST time display every second
    function updateISTDisplay() {
      if (istTimeDisplay) {
        istTimeDisplay.textContent = formatISTTimeDisplay();
      }
    }

    // Check timezone and show clock only if not in IST
    function checkAndDisplayISTClock() {
      const istNotice = document.querySelector('.ist-time-notice');
      if (!istNotice) return;

      // IST is UTC+5:30. getTimezoneOffset() returns minutes (UTC - Local).
      // For IST: UTC - (UTC + 330) = -330.
      const isIST = new Date().getTimezoneOffset() === -330;

      if (!isIST) {
        istNotice.style.display = 'block';
        updateISTDisplay();
        setInterval(updateISTDisplay, 1000);
      }
    }

    // Initialize clock check
    checkAndDisplayISTClock();

    function formatDateForInput(date) {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    function formatDateForDisplay(date) {
      // timeZone: 'UTC' — the date is built as UTC midnight; without this, devices
      // in timezones behind UTC render the previous day (mismatch with Delivery Date ISO)
      const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
      return date.toLocaleDateString('en-IN', options);
    }

    function isDateValid(dateStr) {
      if (!dateStr) return false;

      const selectedDate = new Date(dateStr + 'T00:00:00Z');
      const istNow = getISTDate();
      const minDate = new Date(formatDateForInput(istNow) + 'T00:00:00Z');
      // Same-day delivery closes at 4 PM IST — earliest selectable becomes tomorrow
      if (istNow.getUTCHours() >= 16) {
        minDate.setUTCDate(minDate.getUTCDate() + 1);
      }
      const maxDate = new Date(istNow);
      maxDate.setUTCDate(maxDate.getUTCDate() + 30);

      return selectedDate >= minDate && selectedDate <= maxDate;
    }

    // Set minimum date for delivery based on IST
    function setMinimumDate() {
      const istNow = getISTDate();
      const minDate = new Date(istNow);

      // After 4 PM IST, push the earliest selectable date to tomorrow
      if (istNow.getUTCHours() >= 16) {
        minDate.setUTCDate(minDate.getUTCDate() + 1);
      }

      deliveryDateInput.min = formatDateForInput(minDate);

      const maxDate = new Date(istNow);
      maxDate.setUTCDate(maxDate.getUTCDate() + 30);
      deliveryDateInput.max = formatDateForInput(maxDate);
    }

    // Populate time slots
    function populateTimeSlots() {
      deliveryTimeslotSelect.innerHTML = '';

      timeSlots.forEach((slot) => {
        const option = document.createElement('option');
        option.value = slot.value;
        option.textContent = slot.label;
        deliveryTimeslotSelect.appendChild(option);
      });

      deliveryTimeslotSelect.disabled = false;
      deliveryTimeslotSelect.value = '12pm-6pm';
    }


    // Update cart attributes
    function updateCartAttributes() {
      const deliveryDate = deliveryDateInput.value;
      const deliveryTimeslot = deliveryTimeslotSelect.value;

      if (!deliveryDate || !deliveryTimeslot) {
        return;
      }
      if (!isDateValid(deliveryDate)) {
        dateError.textContent = 'Please select a valid delivery date';
        return;
      }

      const dateObj = new Date(deliveryDate + 'T00:00:00Z');
      const formattedDate = formatDateForDisplay(dateObj);

      const selectedOption = deliveryTimeslotSelect.options[deliveryTimeslotSelect.selectedIndex];
      const timeslotLabel = selectedOption ? selectedOption.textContent : deliveryTimeslot;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'Delivery Date': formattedDate,
            'Delivery Date ISO': deliveryDateInput.value,
            'Delivery Time Slot': timeslotLabel,
            'Order Condition': '',
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Cart attributes updated:', data);
        })
        .catch((error) => {
          console.error('Error updating cart attributes:', error);
        });
    }

   // Optional preferred-time text field with IST validation 15 june 2026 start
    const preferredTimeInput = document.getElementById('delivery-preferred-time');
    const preferredTimeError = document.getElementById('preferred-time-error');

    const PREF_MIN = 12 * 60;  // 12:00 PM in minutes
    const PREF_MAX = 18 * 60;  // 6:00 PM in minutes

    // Parse "3pm", "3 pm", "3:30pm", "15:00", "3", "3.30" -> minutes from midnight, or null
    function parsePreferredTime(raw) {
      if (!raw) return null;
      let s = raw.trim().toLowerCase().replace(/\./g, ':');
      const ampm = s.match(/(am|pm)/);
      s = s.replace(/(am|pm)/g, '').trim();

      let h, m = 0;
      if (s.indexOf(':') !== -1) {
        const parts = s.split(':');
        h = parseInt(parts[0], 10);
        m = parseInt(parts[1], 10);
      } else {
        h = parseInt(s, 10);
      }
      if (isNaN(h) || isNaN(m) || m < 0 || m > 59) return null;

      if (ampm) {
        if (ampm[1] === 'pm' && h < 12) h += 12;
        if (ampm[1] === 'am' && h === 12) h = 0;
      } else {
        // No am/pm: assume 12-hour clock in the delivery window (1-6 means PM)
        if (h >= 1 && h <= 6) h += 12;
      }
      if (h < 0 || h > 23) return null;
      return h * 60 + m;
    }

    function validatePreferredTime() {
      if (!preferredTimeInput) return true;
      preferredTimeError.textContent = '';
      const raw = preferredTimeInput.value.trim();
      if (!raw) return true; // optional, empty is fine

      const mins = parsePreferredTime(raw);
      if (mins === null) {
        preferredTimeError.textContent = 'Please enter a valid time, e.g. 3:30 PM';
        return false;
      }
      if (mins < PREF_MIN || mins > PREF_MAX) {
        preferredTimeError.textContent = 'Time must be between 12:00 PM and 6:00 PM';
        return false;
      }

      // If delivery date is TODAY, the time can't be in the past (IST)
      const selectedDate = deliveryDateInput.value;
      if (selectedDate) {
        const istNow = getISTDate();
        const todayStr = formatDateForInput(istNow);
        if (selectedDate === todayStr) {
          const nowMins = istNow.getUTCHours() * 60 + istNow.getUTCMinutes();
          if (mins < nowMins) {
            preferredTimeError.textContent = 'That time has already passed today. Please choose a later time.';
            return false;
          }
        }
      }
      return true;
    }

    function savePreferredTime() {
      const value = validatePreferredTime() ? preferredTimeInput.value.trim() : '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Preferred Time': value } })
      });
    }

    if (preferredTimeInput) {
      let preferredTimeDebounce;
      preferredTimeInput.addEventListener('input', function () {
        clearTimeout(preferredTimeDebounce);
        preferredTimeDebounce = setTimeout(function () {
          validatePreferredTime();
        }, 400);
      });
      // Save only on blur, after a final validation
      preferredTimeInput.addEventListener('blur', function () {
        savePreferredTime();
      });
    }

    //15 june 2026 end
    // Validate delivery selection
    function validateDeliverySelection() {
      const deliveryDate = deliveryDateInput.value;
      const deliveryTimeslot = deliveryTimeslotSelect.value;

      dateError.textContent = '';
      timeslotError.textContent = '';

      // Always refresh min/max dates before validation
      setMinimumDate();

      let isValid = true;

      if (!deliveryDate) {
        dateError.textContent = 'Please select a delivery date';
        isValid = false;
      } else if (!isDateValid(deliveryDate)) {
        dateError.textContent = 'Invalid date. Same-day delivery closes at 4 PM IST — please choose an available date.';
        isValid = false;
        deliveryDateInput.value = ''; // Clear immediately
      }

      if (!deliveryTimeslot) {
        timeslotError.textContent = 'Please select a time slot';
        isValid = false;
      }

      if (isValid) {
        checkoutButton.classList.remove('checkout-disabled');
        checkoutButton.classList.add('checkout-enabled');
        checkoutButton.setAttribute('data-enabled', 'true');
        checkoutButton.href = '/checkout';
        updateCartAttributes();
      } else {
        checkoutButton.classList.add('checkout-disabled');
        checkoutButton.classList.remove('checkout-enabled');
        checkoutButton.setAttribute('data-enabled', 'false');
        checkoutButton.href = '#';
      }
    }

    // Event listeners
    deliveryDateInput.addEventListener('change', function () {
      if (this.value && !isDateValid(this.value)) {
        dateError.textContent = 'Invalid date selected. Please choose from the calendar.';
        this.value = '';
        return;
      }
      populateTimeSlots();
      validateDeliverySelection();
      validatePreferredTime();
    });

    deliveryDateInput.addEventListener('input', function () {
      if (this.value && !isDateValid(this.value)) {
        dateError.textContent = 'Invalid date';
        this.value = ''; // Clear immediately
        validateDeliverySelection();
      }
    });

    deliveryTimeslotSelect.addEventListener('change', function () {
      validateDeliverySelection();
    });

    // Handle checkout button click with final validation
    // Server-side authoritative date check (runs the validation function via /cart/update.js)
    async function serverValidateDate() {
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { 'Delivery Date ISO': deliveryDateInput.value },
          }),
        });
        if (res.status === 422) {
          const data = await res.json().catch(() => ({}));
          return {
            ok: false,
            message: data.message || 'The selected delivery date is not available. Please choose another date.',
          };
        }
        return { ok: true };
      } catch (e) {
        // Network hiccup: don't block here — the function still enforces at checkout
        return { ok: true };
      }
    }

    // Handle checkout button click with final validation
    checkoutButton.addEventListener('click', async function (e) {
      e.preventDefault(); // always intercept; navigate manually only after all checks pass
      setMinimumDate();

      const deliveryDate = deliveryDateInput.value;
      const isEnabled = checkoutButton.getAttribute('data-enabled') === 'true';
      const currentlyValid = isDateValid(deliveryDate);

      // 1. Client-side checks (instant)
      if (!isEnabled || !currentlyValid || !deliveryDate) {
        dateError.textContent = 'Please select a valid delivery date';
        deliveryDateInput.value = '';
        validateDeliverySelection();
        return;
      }

      // 2. Server-side check (authoritative — catches stale/past dates the UI missed)
      const serverCheck = await serverValidateDate();
      if (!serverCheck.ok) {
        dateError.textContent = serverCheck.message;
        deliveryDateInput.value = '';
        validateDeliverySelection();
        return;
      }

      // 3. All clear → go to checkout
      window.location.href = '/checkout';
    });

    // Initialize (immediate, device-based)
    setMinimumDate();
    populateTimeSlots();
    validateDeliverySelection();

    // Re-run with authoritative server time once it's fetched
    syncServerTime().then(function () {
      setMinimumDate();
      if (deliveryDateInput.value) {
        validateDeliverySelection();
      }
    });

    // Refresh validation periodically (every 5 minutes)
    setInterval(function () {
      setMinimumDate();
      if (deliveryDateInput.value) {
        validateDeliverySelection();
      }
    }, 300000);

    // Revalidate when user returns to page
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && deliveryDateInput.value) {
        setMinimumDate();
        validateDeliverySelection();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scopeEl) {
      var $ = window.jQuery;
      if (!$ || !$.fn || !$.fn.slick) return;

      var $slider = $(scopeEl).find('.slick-side-h1');
      if ($slider.length === 0 || $slider.hasClass('slick-initialized')) return;

      // Lazyload fallback: make sure images have src
      var $imgs = $slider.find('img');
      if (typeof window.lazySizes === 'undefined') {
        $imgs.each(function () {
          var ds = this.getAttribute('data-src');
          if (ds && !this.getAttribute('src')) this.setAttribute('src', ds);
        });
      }

      // Read config from data-attrs on the section wrapper
      var ds = scopeEl.dataset;
      var style = ds.autoplayStyle || 'continuous';
      var enableAutoplay = ds.autoplay === 'true';
      var pauseOnHover = ds.pauseOnHover !== 'false';
      var showArrows = ds.arrows !== 'false';
      var showDots = ds.dots !== 'false';
      var fade = ds.fade === 'true';

      var slideInterval = parseInt(ds.autoplayInterval || '4000', 10);
      var continuousSpeed = parseInt(ds.continuousSpeed || '8000', 10);

      var slickOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: showArrows,
        dots: showDots,
        pauseOnHover: pauseOnHover,
        pauseOnFocus: false,
        autoplay: enableAutoplay,
        draggable: true,
        swipeToSlide: true,
        adaptiveHeight: false,
      };

      if (style === 'continuous' && enableAutoplay) {
        slickOptions.autoplaySpeed = 0;
        slickOptions.speed = continuousSpeed;
        slickOptions.cssEase = 'linear';
        slickOptions.fade = false; // fade doesn't make sense for continuous
      } else {
        slickOptions.autoplaySpeed = slideInterval;
        slickOptions.speed = 800;
        slickOptions.cssEase = 'ease';
        slickOptions.fade = fade; // only used for slide-by-slide
      }

      // Wait for images so Slick gets widths
      var total = $imgs.length,
        loaded = 0,
        started = false;
      function maybeStart() {
        if (started) return;
        if (total > 0 && loaded < total) return;
        started = true;
        $slider.slick(slickOptions);
      }

      if (total === 0) {
        maybeStart();
      } else {
        $imgs.each(function () {
          if (this.complete) {
            loaded++;
            maybeStart();
          } else {
            $(this).one('load error', function () {
              loaded++;
              maybeStart();
            });
          }
        });
        maybeStart();
      }
    }

    function initAll(root) {
      var nodes = (root || document).querySelectorAll('[data-section-type="section-slideshow-v1"]');
      nodes.forEach(init);
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var $ = window.jQuery;
      if (!$ || !$.fn || !$.fn.slick) return;
      var $slider = $(e.target).find('.slick-side-h1');
      if ($slider.length && $slider.hasClass('slick-initialized')) $slider.slick('unslick');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
